import { logger } from 'lib/logger';
import { PushResubscribeAPICall } from 'reactApp/api/PushResubscribeAPICall';

export const FEATURE_NAME = 'web-push';

/** Сегмент xray-события тултипа «уведомления заблокированы» (show/click/close). */
export const XRAY_BLOCKED_TOOLTIP = 'blocked-tooltip';

/** Сегмент xray-события экрана «уведомления заблокированы» (show/close). */
export const XRAY_BLOCKED_SCREEN = 'blocked-screen';

/** Сегмент xray-события запроса разрешения (granted/denied/default/error). */
export const XRAY_PERMISSION = 'permission';

/** Сегмент xray-события диплинк-пуша на стороне page (open/fallback/rejected). */
export const XRAY_DEEPLINK = 'deeplink';

export type Provider = 'fcm' | 'pushme';

/** Единственный инстанс API для отправки регистрации на сервер (fcm-токен / pushme-подписка). */
export const api = new PushResubscribeAPICall();

export const log = (...params: unknown[]) => {
    logger.verbose('[web-push]', ...params);
};
